<template>
  <div class="earlyWarn">
    <div class="index-header">
      <span class="title">
        <svg-icon icon-class="warn" class="iconstyle"></svg-icon>预警管理
      </span>
      <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="container" ref="container">
      <div class="warn">
        <li class="ft12" v-for="(item,index) in list" :key="index" @click="jumpMore">
          <span class="title ub-f1">{{item.Name}}</span>
          <!-- <span class="time">{{(item.CreateTime.replace('T'," "))|| formatDate('yyyy-MM-dd')}}</span> -->
          <span class="time">{{item.CreateTime | formatDate('yyyy-MM-dd')}}</span>
        </li>
      </div>
      <!-- <div class="Img" v-if="showNoMessageImg">
        <img src="@/components/indexnew/img/noMessage.png">
      </div>-->
    </div>
  </div>
</template>

<script>
import { EarlyWarningControllerSvr } from "@/service/EarlyWarningControllerSvr/EarlyWarningControllerSvr.js";
import commonTitle from "@/assets/js/commonTitle.js";
import { mapState } from "vuex";
export default {
  components: {},
  props: ["messageshowbtn"],
  data() {
    return {
      //showNoMessageImg: true,
      listNum: 0,
      strartIndex: 0,
      maxSize: 3,
      key: "",
      list: []
    };
  },
  computed: {
    ...mapState(["token"])
  },
  created() {
    this.EarlyWarningControllerSvr = new EarlyWarningControllerSvr();
  },
  mounted() {
    this.getdate();
  },
  methods: {
    jumpMore() {
      this.$router.push({
        path: "/earlyWaringMore",
        query: { t: Date.now() }
      });
      //  this.$message("暂无消息");
    },
    getdate() {
      const myworkLoading = this.$loading({
        target: document.querySelector(".warn")
      });
      this.EarlyWarningControllerSvr.GetEarlyWarningList(
        this.token,
        this.key,
        2,
        this.strartIndex,
        this.maxSize
      )
        .then(res => {
          this.list = res._Items;
          this.listNum = res.TotalCount;
          myworkLoading.close();
        })
        .catch(() => {
          myworkLoading.close();
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./css/common.scss";
.earlyWarn {
  background: #fff;
  .iconstyle {
    font-size: 18px;
    margin: 0 6px;
    color: #ff4546;
  }
  .container {
    height: 125px;
    padding: 10px 0;
    overflow: hidden;
    // .Img {
    //   padding: 5px 12px;
    //   display: flex;
    //   justify-content: center;
    //   align-items: center;
    // }
    .warn {
      li {
        padding: 5px 12px;
        display: flex;
        justify-content: space-between;
        height: 35px;
        box-sizing: border-box;
        line-height: 25px;
        cursor: pointer;
        .title {
          font-size: 14px;
          line-height: 30px;
          position: relative;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .time {
          font-size: 14px;
          line-height: 30px;
          color: #666;
        }
        &:nth-child(2n) {
          background: #f7f8fa;
        }
        &:hover {
          background: #e3f0ff;
        }
      }
    }
  }
}
</style>
